/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleRegularTriggerDto } from './equipment-schedule-regular-trigger-dto';


export interface CreateEquipmentRegularScheduleRequestDto { 
    name?: string | null;
    triggers?: Array<EquipmentScheduleRegularTriggerDto> | null;
}

